import React, { Component } from 'react';
import Helmet from 'react-helmet';
import striptags from 'striptags';

import pageData from '../../data/index.json';
import postData from '../../data/posts.json';

import { Hero } from './Hero';
import { Section } from './Section';
import { Posts } from './Posts';
import { largeMargin } from '../margins';
import { Navigation } from './Navigation';
import { primary } from '../colors';
import { fixImageSrc } from './Image';

export class StartPage extends Component {
  render() {
    const logo = pageData.logo;
    const hero = pageData.hero;
    const primaryButtonPost = postData.filter(
      post => post.id === pageData.primaryButton
    )[0];
    const leftButtonData = pageData.leftButton;
    let leftButtonPost = null;
    if (leftButtonData) {
      leftButtonPost = postData.filter(
        post => post.id === pageData.leftButton
      )[0];
    }
    const aboutHeading = pageData.aboutHeading;
    const sortedPostData = postData.sort((a, b) => a.menuOrder - b.menuOrder);
    const title = 'Styrelsen Bar & Bistro';
    return [
      <Helmet key="helmet">
        <meta name="theme-color" content={primary} />
        <title>{title}</title>
        <meta property="og:url" content="https://www.styrelsen.nu" />
        <meta property="og:type" content="restaurant.restaurant" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={striptags(pageData.content)} />
        <meta
          property="og:image"
          content={fixImageSrc(
            hero.url,
            {
              width: 1200,
              height: 600,
              cover: true,
            },
            {
              extra: 'b_black,o_60',
              overlay: {
                url: logo.url.replace(
                  'http://s3-eu-west-2.amazonaws.com/styrelsen/',
                  'https://www.styrelsen.nu/'
                ),
                extra: 'w_700,g_center',
              },
              ...hero.cloudinary,
            }
          )}
        />
        <meta property="og:image:alt" content={hero.alt} />
        <meta property="og:locale" content="sv_SE" />
      </Helmet>,
      <Navigation
        key="navigation"
        phoneNumber={pageData.phoneNumber}
        posts={sortedPostData}
      />,
      <Hero
        key="hero"
        hero={hero}
        logo={logo}
        primaryButton={{
          href: primaryButtonPost.slug,
          text: primaryButtonPost.heading,
        }}
        leftButton={
          leftButtonData && {
            href: leftButtonPost.slug,
            text: leftButtonPost.heading,
          }
        }
      />,
      <Section
        key="about"
        css={`
          margin-bottom: ${largeMargin};
        `}
        heading={aboutHeading}
        content={pageData.content}
      />,
      <Posts
        key="posts"
        posts={sortedPostData}
        phoneNumber={pageData.phoneNumber}
      />,
    ];
  }
}



// WEBPACK FOOTER //
// ./app/components/StartPage.js